const breakpoints = {
  xs: '480px',
  md: '768px',
  lg: '1200px',
};

export const devices = {
  xs: `(min-width: ${breakpoints.xs})`,
  md: `(min-width: ${breakpoints.md})`,
  lg: `(min-width: ${breakpoints.lg})`,
};
